import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      submenuSelector,
      submenuTogglerSelector,
      submenuL1Selector,
      submenuL1TogglerSelector,
      menuTogglerSelector,
      menuContainerMobileSelector,
      menuContainerSelector,
      searchTogglerSelector,
      searchContainerSelector,
      searchFormInput,
      languageTogglerSelector,
      languageContainerSelector,
      headerSelector,
      scrollDistance,
      headerPolyfillSelector,
      metaTogglerSelector,
      metaContainerSelector
    } = config;

    this.body = document.querySelector("body");
    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.submenuSelector = submenuSelector;
    this.submenuL1Toggler = document.querySelectorAll(submenuL1TogglerSelector);
    this.subL1TogglerArray = Array.prototype.slice.call(this.submenuL1Toggler);
    this.submenuL1Selector = submenuL1Selector;
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.menuMobileContainer = document.querySelector(menuContainerMobileSelector);
    this.searchToggler = document.querySelectorAll(searchTogglerSelector);
    this.searchTogglerArray = Array.prototype.slice.call(this.searchToggler);
    this.searchContainer = document.querySelector(searchContainerSelector);
    this.searchFormInput = document.querySelector(searchFormInput);
    this.languageToggler = document.querySelectorAll(languageTogglerSelector);
    this.languageTogglerArray = Array.prototype.slice.call(this.languageToggler);
    this.languageContainer = document.querySelector(languageContainerSelector);
    this.headerSelector = document.querySelector(headerSelector);
    this.scrollDistance = scrollDistance;
    this.headerPolyfillSelector = document.querySelector(headerPolyfillSelector);
    this.metaToggler = document.querySelector(metaTogglerSelector);
    this.metaContainer = document.querySelector(metaContainerSelector);
    this.searchOpen = false;
    this.searchFocus = false;
    this.languageOpen = false;
    this.submenuOpen = false;
    this.menuOpen = false;
    this.metaOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.menuToggler.addEventListener("click", (e) => {
      this.toggleMenu();
    });

    this.subTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenu(toggle);
        if (Helper.isDesktop()) {
          this.closeLanguage();
          this.closeSearch();
        }
      });
    });

    this.subL1TogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenuL1(toggle);
      });
    });

    this.languageTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        if (Helper.isDesktop()) {
          this.toggleLanguage();
        }
        this.closeAllSubmenus();
        this.closeSearch();
      });
    });

    this.searchTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        console.log(Helper.isDesktop());
        if (Helper.isDesktop()) {
          this.toggleSearch();
        }
        this.closeAllSubmenus();
        this.closeLanguage();
      });
    });

    this.searchFormInput.addEventListener("focusin", (e) => {
      this.searchInputFocusIn();
    });

    this.searchFormInput.addEventListener("focusout", (e) => {
      this.searchInputFocusOut();
    });

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllSubmenus();
        this.closeSearch();
        this.menuOpen = true;
        //this.toggleMenu();
        Helper.removeClass(this.body, "submenu-is-open");
        Helper.removeClass(this.body, "search-open");
        Helper.removeClass(this.body, "language-open");
      }
    };
  }

  toggleMenu() {
    if (this.menuOpen) {
      Helper.removeClass(this.menuToggler, "burger-active");
      Helper.slideUp(this.menuMobileContainer);
      Helper.removeClass(this.body, "menu-open");
      this.menuOpen = false;
    } else {
      Helper.addClass(this.menuToggler, "burger-active");
      Helper.slideDown(this.menuMobileContainer);
      Helper.addClass(this.body, "menu-open");
      this.menuOpen = true;
    }
  }

  toggleSubmenu(toggle) {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    const currentSubmenu = toggle.nextElementSibling;

    Helper.slideToggle(currentSubmenu);
    Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");
    const activeL1 = currentSubmenu.querySelector('.menu__item--level-1.menu__item--ancestor-active');
    if (Helper.hasClass(currentSubmenu.parentElement, "submenu-open")) {
      if ( activeL1 !== null && !Helper.hasClass(activeL1, "submenu-open")) {
        activeL1.querySelector('.menu__link').click();
      }
    }
    submenus.forEach((submenu) => {
      if (submenu != currentSubmenu) {
        Helper.slideUp(submenu);
        Helper.removeClass(submenu.parentElement, "submenu-open");
      }
    });
    submenus.forEach((submenu) => {
      if (Helper.hasClass(submenu.parentElement, "submenu-open")) {
        this.submenuOpen = true;
      }
    });
    if (this.submenuOpen) {
      Helper.addClass(this.body, "submenu-is-open");
      this.submenuOpen = false;
    } else {
      Helper.removeClass(this.body, "submenu-is-open");
      this.submenuOpen = true;
    }
  }

  toggleSubmenuL1(toggle) {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuL1Selector)
    );
    const currentSubmenu = toggle.nextElementSibling;

    if (window.screen.width >= 1024) {
      Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");
      submenus.forEach((submenu) => {
        if (submenu != currentSubmenu) {
          Helper.removeClass(submenu.parentElement, "submenu-open");

          let submenuInner = submenu.closest('.menu__inner--level-1');
          submenuInner.style.removeProperty("height");
        }
      });

      let menuInner = currentSubmenu.closest('.menu__inner--level-1');

      if ( currentSubmenu.parentElement.classList.contains('submenu-open') ) {
        const subHeight = currentSubmenu.scrollHeight+"px";
        console.log(subHeight);
        menuInner.style.height = subHeight;
      } else {
        menuInner.style.removeProperty("height");
      }


    } else {
      Helper.slideToggle(currentSubmenu);
      Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");

      submenus.forEach((submenu) => {
        if (submenu != currentSubmenu) {
          Helper.slideUp(submenu);
          Helper.removeClass(submenu.parentElement, "submenu-open");
        }
      });
    }
  }

  closeAllSubmenus() {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    Helper.removeClass(this.body, "submenu-is-open");
    submenus.forEach((submenu) => {
      Helper.slideUp(submenu);
      Helper.removeClass(submenu.parentElement, "submenu-open");
    });
    this.submenuOpen = false;
  }

  toggleLanguage() {
    if (this.languageOpen) {
      this.closeLanguage();
    } else {
      this.languageTogglerArray.forEach((toggle) => {
        Helper.addClass(toggle, "language-active");
      });
      Helper.slideDown(this.languageContainer);
      Helper.addClass(this.body, "language-open");
      this.languageOpen = true;
    }
  }

  closeLanguage() {
    this.languageTogglerArray.forEach((toggle) => {
      Helper.removeClass(toggle, "language-active");
    });
    Helper.slideUp(this.languageContainer);
    Helper.removeClass(this.body, "language-open");
    this.languageOpen = false;
  }

  toggleSearch() {
    console.log("search");
    if (this.searchOpen) {
      this.closeSearch();
    } else {
      this.searchTogglerArray.forEach((toggle) => {
        Helper.addClass(toggle, "search-active");
      });
      Helper.slideDown(this.searchContainer);
      Helper.addClass(this.body, "search-open");

      this.searchContainer.querySelector("input").focus();
      this.searchOpen = true;
    }
  }

  closeSearch() {
    this.searchTogglerArray.forEach((toggle) => {
      Helper.removeClass(toggle, "search-active");
    });
    Helper.slideUp(this.searchContainer);
    Helper.removeClass(this.body, "search-open");
    this.searchOpen = false;
  }

  searchInputFocusIn() {
    if (this.searchFocus) {
      Helper.removeClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = false;
    } else {
      Helper.addClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = true;
    }
  }

  searchInputFocusOut() {
    if (this.searchFocus) {
      Helper.removeClass(this.searchFormInput.parentNode, 'has-focus')
      this.searchFocus = false;
    }
  }
}

export default Header;
